import { escapeReceiptHtml } from './format';
import type { ReceiptWidthMm } from './types';

const DEFAULT_WIDTH: ReceiptWidthMm = 72;

export function thermalHtmlStyles(widthMm: ReceiptWidthMm = DEFAULT_WIDTH): string {
  return `
  @page { margin: 4mm; size: ${widthMm}mm auto; }
  @media print { body { margin: 0; } }
  body {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px; color: #111; margin: 0; padding: 6px;
    max-width: ${widthMm}mm; width: ${widthMm}mm; box-sizing: border-box;
  }
  .title {
    text-align: center; font-size: 20px; font-weight: 800;
    letter-spacing: 0.08em; line-height: 1.1; margin: 4px 0 2px;
  }
  .center { text-align: center; }
  .meta { margin: 2px 0; }
  .sep { border: none; border-top: 1px solid #111; margin: 8px 0; }
  table { width: 100%; border-collapse: collapse; }
  td { vertical-align: top; padding: 2px 0; }
  td.qty { width: 2.2em; white-space: nowrap; }
  td.name { word-break: break-word; }
  td.name .mod { font-size: 11px; margin-top: 1px; }
  td.price { text-align: right; white-space: nowrap; padding-left: 6px; }
  .row { margin: 2px 0; }
  .total { font-weight: 800; font-size: 14px; margin-top: 4px; }
  .foot { text-align: center; font-size: 10px; margin-top: 10px; }
  .void-banner {
    text-align: center; font-weight: 800; font-size: 14px;
    border: 2px solid #111; padding: 4px; margin: 6px 0;
  }
`;
}

export function wrapThermalHtml(body: string, widthMm: ReceiptWidthMm = DEFAULT_WIDTH): string {
  return `<!DOCTYPE html>
<html><head><meta charset="utf-8"/>
<style>${thermalHtmlStyles(widthMm)}</style></head><body>
${body}
</body></html>`;
}

export function thermalItemRowsHtml(
  lines: Array<{
    name: string;
    qty: number;
    lineTotal: number;
    optionsLabel?: string | null;
    lineNote?: string | null;
  }>
): string {
  return lines
    .map((line) => {
      const opts = line.optionsLabel?.trim() || '';
      const note = line.lineNote?.trim() || '';
      const meta = [
        opts ? `<div class="mod">${escapeReceiptHtml(opts)}</div>` : '',
        note ? `<div class="mod">Nota: ${escapeReceiptHtml(note)}</div>` : '',
      ].join('');
      return `<tr><td class="qty">${escapeReceiptHtml(String(line.qty))}×</td><td class="name">${escapeReceiptHtml(line.name)}${meta}</td><td class="price">${formatReceiptMoneyInline(line.lineTotal)}</td></tr>`;
    })
    .join('');
}

function formatReceiptMoneyInline(n: number): string {
  return `$${Math.round(n).toLocaleString('es-AR')}`;
}
